<template>
  <el-dialog
    title="修改密码"
    custom-class="custom-dialog"
    width="350px"
    :lock-scroll="false"
    :append-to-body="true"
    @close="handleCancel"
    :close-on-click-modal="false"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <el-form
      :model="form"
      label-width="80px"
      size="small"
      label-position="left"
    >
      <el-form-item label="用户账号">
        <el-input :value="user.account" readonly></el-input>
      </el-form-item>
      <el-form-item label="新密码">
        <el-input
          type="password"
          v-model="form.newPassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input
          type="password"
          v-model="form.confirmPassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取 消</el-button>
      <el-button type="primary" @click="changePwd">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AUTH from "@/api/auth";
import { mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        newPassword: "",
        confirmPassword: ""
      }
    };
  },
  computed: {
    ...mapState(["user"])
  },
  methods: {
    async changePwd() {
      try {
        let response = await AUTH.CHGPWD(this.form);
        if (response.data.state) {
          this.$message.success("密码修改成功");
        } else {
          this.$message.warning(response.data.message);
        }
      } catch {
        this.$message.warning("操作失败");
      }
      // getToken(this.form).then(res => {
      //     if (res.code === 0) {
      //         this.$store.dispatch('loginAction', res.data);
      //         this.$emit('hide');
      //         this.$notify.success({
      //             title: '成功',
      //             message: '密码修改成功!',
      //             duration: 1000
      //         });
      //     } else {
      //         this.$notify.warning({
      //             title: '警告',
      //             message: res.msg,
      //             duration: 2000
      //         });
      //     }
      // });
    },
    handleCancel() {
      this.form.newPassword = "";
      this.form.confirmPassword = "";
    }
  }
};
</script>
<style lang="less" scoped>
.custom-dialog {
  .el-dialog__header {
    padding: 20px 30px 10px;
    .el-dialog__title {
      font-size: 16px;
    }
  }
  .el-dialog__body {
    padding: 10px 35px 5px 30px;
    .el-form-item__label {
      font-size: 13px;
    }
  }
  .el-dialog__footer {
    padding: 20px 35px 20px 30px;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
}
</style>
